module.exports = __webpack_public_path__ + "img/1372389345.461244c7.jpg";